var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.437 7.875h-2.57l-.368-.982c-.43-1.149-1.191-2.126-2.2-2.825C17.29 3.37 16.11 3 14.881 3H9.118c-1.227 0-2.408.37-3.417 1.068-1.009.7-1.77 1.676-2.2 2.825l-.369.982H.562c-.383 0-.654.376-.533.74L.404 9.74c.077.23.292.385.534.385h1.35l-.002.007C1.37 10.645.75 11.625.75 12.75V15c0 .76.284 1.454.75 1.983v2.892c0 .621.504 1.125 1.125 1.125h2.25C5.496 21 6 20.496 6 19.875V18h12v1.875c0 .621.504 1.125 1.125 1.125h2.25c.621 0 1.125-.504 1.125-1.125v-2.892c.466-.529.75-1.223.75-1.983v-2.25c0-1.125-.62-2.105-1.536-2.618l-.003-.007h1.351c.242 0 .457-.155.534-.385l.375-1.125c.121-.364-.15-.74-.534-.74zM6.31 7.947C6.746 6.782 7.875 6 9.118 6h5.763c1.244 0 2.373.782 2.81 1.947l.676 1.803H5.633l.677-1.803zm-2.185 7.428c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5 2.25 1.422 2.25 2.25c0 .828-1.422.75-2.25.75zm15.75 0c-.828 0-2.25.078-2.25-.75s1.422-2.25 2.25-2.25c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.1a13fbad1221ab909256157d9fe68d84.svg";
export { ForwardRef as ReactComponent };